import {useState,useEffect} from 'react'
import axios from '../../axios'
const Trainer = ({value,handleInputChange,course,dont ,imp}) => {
    const [trainer, setTrainer ] = useState([]);
    useEffect(() => {
      const fetchTrainer = async () => {
        try {
          const response = await axios.get(`trainer/gettrainer/${course}`);
          setTrainer(response.data);
        } catch (error) {
          console.error('Error fetching trainer:', error);
        }
      };
  
      fetchTrainer();
    }, [course]);
    // console.log('course is',course)
    return (
      <div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="course-code">
          Trainer Name {imp && <span className="text-red-600">*</span>}
        </label>
          <select
          id="course-code"
          value={value}
          disabled={dont}
          onChange={handleInputChange}
          className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
          >
            <option value="" disabled>Select Trainer
            </option>
          {trainer.map((course) => (
            <option key={course.trainer_id} value={course.trainer_id}>
              {course.trainer_name}
            </option>
          ))}
        </select>
       
        
       
      </div>
    );
  };  
  
  export default Trainer;